/// <amd-module name="Agile/Common/Redux/HubTeam/HubTeamSelector" />
import { IHubTeamAwareState } from "Agile/Common/Redux/HubTeam/HubTeamContracts";
import { ITeam } from "Agile/Contracts/Common";

export function getTeam(state: IHubTeamAwareState): ITeam {
    if (!state.hubteamState.team) throw Error("Team information is not loaded yet");
    return state.hubteamState.team;
}
